import React, { useState, useEffect, useRef } from 'react';
import {
  InstantSearch,
  Index,
  Hits,
  connectStateResults,
} from 'react-instantsearch-dom';
import algoliasearch from 'algoliasearch/lite';
import { SearchContainer, HitsWrapper, ResultHeader } from './search-css';
import Input from './search-input';
import * as hitComponents from './hit-components';

const Results = connectStateResults(
  ({ searchState: state, searchResults: res, children }) => (
    res && res.nbHits > 0 ? children : (
      <ul>
        <li>No results for '{state.query}'</li>
      </ul>
    )
  ),
);
const Stats = connectStateResults(
  ({ searchResults: res }) => (
    res && res.nbHits > 0 && `${res.nbHits} result${res.nbHits > 1 ? 's' : ''}`
  ),
);

const useClickOutside = (ref, handler, events = ['mousedown', 'touchstart']) => {
  const detectClickOutside = (event) => !ref.current.contains(event.target) && handler();
  useEffect(() => {
    events.forEach((event) => document.addEventListener(event, detectClickOutside));
    return () => {
      events.forEach((event) => document.removeEventListener(event, detectClickOutside));
    };
  });
};

const Search = ({ indices, collapse, header, placeholders }) => {
  const ref = useRef();
  const [searchQuery, setSearchQuery] = useState('');
  const [focus, setFocus] = useState(false);

  const algoliaClient = algoliasearch(
    process.env.GATSBY_ALGOLIA_APP_ID,
    process.env.GATSBY_ALGOLIA_SEARCH_KEY,
  );

  const searchClient = {
    search(requests) {
      // do not send request to Algolia if search is blank
      // return mock response instead
      if (requests.every(({ params }) => !params.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
          })),
        });
      }
      return algoliaClient.search(requests);
    },
  };

  useClickOutside(ref, () => setFocus(false));

  return (
    <SearchContainer ref={ref} header={header}>
      <InstantSearch
        searchClient={searchClient}
        indexName={indices[0].name}
        onSearchStateChange={({ query }) => setSearchQuery(query)}
      >
        <Input
          enablesReturnKeyAutomatically={false}
          onFocus={() => setFocus(true)} {...{ collapse, focus }}
          onKeyPress={({ key}) => {
            if(key==='Enter') {
              return false;
            }
          }}
          header={header}
          placeholders={placeholders}
        />
        <HitsWrapper show={searchQuery.length > 0 && focus}>
          {indices.map(({ name, hitComponent }) => (
            <Index key={name} indexName={name}>
              {header && (
                <header>
                  <ResultHeader>
                    <Stats />
                  </ResultHeader>
                </header>
              )}
              <Results>
                <Hits hitComponent={hitComponents[hitComponent](() => setFocus(false))} />
              </Results>
            </Index>
          ))}
          {/* <PoweredBy /> */}
        </HitsWrapper>
      </InstantSearch>
    </SearchContainer>
  );
};

export default Search;
